import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { money } from '../../utils/format';

function getReceiptValue(bets, value) {
    if (!bets || bets.isEmpty() || !value) {
        return void 0;
    }

    return bets
        .map(x => x.get(value))
        .reduce((pv, v) => pv + v);
}

class BetReceipt extends React.Component {
    static propTypes = {
        bets: ImmutablePropTypes.list,
        currency: PropTypes.string
    };

    render() {
        const { bets, currency } = this.props;

        return (
            <div className='betslip__bet-receipt' key='betslip:receipt'>
                <header data-test='betslip-bet-receipt-header'>BET RECEIPT</header>

                <p data-test='betslip-bet-receipt-message'>Bet(s) have been successfully placed</p>

                <ul>
                    <li>
                        <span data-test='betslip-bet-receipt-total-stake'>Total Stake</span>
                        <b data-test='betslip-bet-receipt-total-stake-value'>{ money(getReceiptValue(bets, 'totalStake'), currency) }</b>
                    </li>
                    <li>
                        <span data-test='betslip-bet-receipt-total-potential-returns'>Total Potential Returns</span>
                        <b data-test='betslip-bet-receipt-total-potential-returns-value'>{ money(getReceiptValue(bets, 'potentialReturns'), currency) }</b>
                    </li>
                </ul>
            </div>
        );
    }
}

export default BetReceipt;
